import React from "react";
import { useParams } from "react-router";
import { Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import BuildingLoadingView from "components/loading/BuildingLoadingView/BuildingLoadingView";
import { useSportObjectLoading } from "hooks/loading";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";

export default function BuildingLoadingPage() {
    const { regionId, municipalityId, buildingId } = useParams();
    const { isLoading, data } = useSportObjectLoading(buildingId);
    const { flags, isLoading: isContextLoading } = useContextPerson();

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/loading/region/${regionId}/municipality/${municipalityId}/`}
                        text={"Назад"}
                        name={"region_building_back_link"}
                    />
                )}

                <BuildingLoadingView data={data} />
            </>
        );
    }
}
